/**
 * Created by dizzy on 27.02.19.
 */
callpy_global.CAutos = function()
{
    this.module_name = "Autos ";
    this.module_log_rang = 100;

    var _this = this;

    this.savedData = {}; //сохранённые данные по выполненности условий (id, сколько раз сработало, следующий сброс). Данные хранятся в LS, рассмотреть возможность хранить на сервере
    this.savedCondData = {}; //здесь хранятся данные по условиям - что выполнилось и когда в последний раз

    this.showButtonFormTimer = {}; //таймеры для показа формы кнопок, чтобы не выводить форму сразу же после нажатия на ее кнопки
    this.buttonFormTimerSec = 500; //миллисек

    this.init = function()
    {
        if (localStorage["callpy_conditions"]){ //здесь хранятся данные по действиям (сколько раз выполнялось и т.д.)
            try{
                _this.savedData = JSON.parse(localStorage["callpy_conditions"]);
            }catch (e){
                _this.savedData = {};
            }
        }
        if (localStorage["callpy_site_conditions"]){ //здесь хранятся данные по условиям - что выполнилось и когда в последний раз
            try{
                _this.savedCondData = JSON.parse(localStorage["callpy_site_conditions"]);
            }catch (e){
                _this.savedCondData = {};
            }
        }
        //инициализация данных по условиям
        _this.checkAllConditions();
        _this.checkTimeoutCondition();

        //UPD: перенести в Комус
        if (m_callpy.client_data.site_id == 19319 || m_callpy.client_data.site_id == 19127){
            //есть ли дополнительные данные
            if ($('#callpydata') && $('#callpydata').data('callpy')){
                var kdata = $('#callpydata').data('callpy');
                if (kdata.companyId){
                    callpy_api.user('setCustomData', {
                        "komus_companyId": {
                            title: "company ID",
                            data: kdata.companyId
                        }
                    });
                }
                if (kdata.companyName){
                    callpy_api.user('setCustomData', {
                        "komus_companyName": {
                            title: "Имя компании",
                            data: kdata.companyName
                        }
                    });
                }
                if (kdata.contactPhone){
                    callpy_api.user('setCustomData', {
                        "komus_contactPhone": {
                            title: "Телефон",
                            data: kdata.contactPhone
                        }
                    });
                }
                if (kdata.entries){
                    callpy_api.user('setCustomData', {
                        "komus_basket": {
                            title: "Корзина",
                            data: JSON.stringify(kdata.entries)
                        }
                    });
                }
                if (kdata.isAnonymous !== undefined){
                    callpy_api.user('setCustomData', {
                        "komus_isAnonymous": {
                            title: "Зарегистрирован",
                            data: kdata.isAnonymous ? "нет" : "да"
                        }
                    });
                }
                if (kdata.lastCheckoutStep){
                    callpy_api.user('setCustomData', {
                        "komus_lastCheckoutStep": {
                            title: "Последний шаг корзины",
                            data: kdata.lastCheckoutStep
                        }
                    });
                }
                if (kdata.salesRepresentativeEmail){
                    callpy_api.user('setCustomData', {
                        "komus_salesRepresentativeEmail": {
                            title: "Email ТП",
                            data: kdata.salesRepresentativeEmail
                        }
                    });
                }
                if (kdata.salesRepresentativeId){
                    callpy_api.user('setCustomData', {
                        "komus_salesRepresentativeId": {
                            title: "ID ТП",
                            data: kdata.salesRepresentativeId
                        }
                    });
                }
                if (kdata.salesRepresentativeName){
                    callpy_api.user('setCustomData', {
                        "komus_salesRepresentativeName": {
                            title: "Имя ТП",
                            data: kdata.salesRepresentativeName
                        }
                    });
                }
                if (kdata.salesRepresentativePhone){
                    callpy_api.user('setCustomData', {
                        "komus_salesRepresentativePhone": {
                            title: "Телефон ТП",
                            data: kdata.salesRepresentativePhone
                        }
                    });
                }
                if (kdata.userEmail){
                    callpy_api.user('setCustomData', {
                        "komus_userEmail": {
                            title: "Email",
                            data: kdata.userEmail
                        }
                    });
                }
                if (kdata.userName){
                    callpy_api.user('setCustomData', {
                        "komus_userName": {
                            title: "Имя",
                            data: kdata.userName
                        }
                    });
                }
            }
        }

    };

    /**
     * Возвращает час с учётом зоны
     * @param offset
     * @returns {number}
     */

    this.getHoursZone = function (offset) {
        var d, utc, nd;
        d = new Date();
        utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        nd = new Date(utc + (3600000 * offset));
        return nd.getHours();
    };

    /**
     * Проверяет и запускает следующую проверку по setTimeout, если это необходимо
     */

    this.checkTimeoutCondition = function()
    {
        var minTime, curTime = new Date().getTime(), leftTime;
        //проверка, существуют ли активные счётчики по условиям, и установка следующей проверки
        if (m_callpy.client_data.site_info.auto){
            for (var siteCondId in m_callpy.client_data.site_info.auto){
                for (var c_id in m_callpy.client_data.site_info.auto[siteCondId]['conditions']) {
                    switch (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].type) {
                        case 'SITE_TIME':
                            leftTime = (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data * 1000) - (curTime - m_callpy.m_user.last_visit_time);
                            if (leftTime > 0){
                                if (!minTime) minTime = leftTime;
                                else minTime = Math.min(leftTime, minTime);
                            }
                            break;
                        case 'PAGE_TIME':
                            leftTime = (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data * 1000) - (curTime - m_callpy.m_user.last_page_time);
                            if (leftTime > 0){
                                if (!minTime) minTime = leftTime;
                                else minTime = Math.min(leftTime, minTime);
                            }
                            break;
                        case 'NO_ANSWER':
                            //определим соотв. время
                            var last_message_time = curTime;
                            for (var i = m_callpy.m_chat.history.length - 1; i>=0; i--){
                                //сообщение самого клиента
                                if (last_message_time - m_callpy.m_chat.history[i].timestamp * 1000 > 30*60*1000 || m_callpy.m_chat.history[i].recieved != 0){
                                    //сообщение относится к другому диалогу, либо было чье-то сообщение
                                    break;
                                }
                                last_message_time = m_callpy.m_chat.history[i].timestamp * 1000;
                            }
                            leftTime = curTime - last_message_time;
                            if (leftTime > 0){
                                leftTime = m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data * 1000 - leftTime;
                                if (leftTime > 0){
                                    if (!minTime) minTime = leftTime;
                                    else minTime = Math.min(leftTime, minTime);
                                }
                            }
                            break;
                    }
                }
            }
            if (minTime){
                setTimeout(function(){
                    _this.checkAllConditions();
                    _this.checkTimeoutCondition();
                }, minTime);
            }
        }
    };

    /**
     * Метод проверяет все существующие условия на выполненность
     */
    this.checkAllConditions = function(data)
    {
        var executed, executed_partially;
        if (!m_callpy.client_data.site_info.auto) return;
        for (var siteCondId in m_callpy.client_data.site_info.auto){
            if (!m_callpy.client_data.site_info.auto.hasOwnProperty(siteCondId)) continue;
            //console.log("Проверка условия №", siteCondId);
            executed = true;
            executed_partially = false;
            if (siteCondId == 1753 || siteCondId == 1755 || siteCondId == 1757){
                if ($('#callpydata') && $('#callpydata').data('callpy')){
                    var kdata = $('#callpydata').data('callpy');
                    if (kdata.isAnonymous !== undefined){
                        if (kdata.isAnonymous){

                        }else{
                            executed = false;
                        }
                    }
                }
            }
            if (siteCondId == 1759 || siteCondId == 1761 || siteCondId == 1763){
                if ($('#callpydata') && $('#callpydata').data('callpy')){
                    var kdata = $('#callpydata').data('callpy');
                    if (kdata.isAnonymous !== undefined){
                        if (!kdata.isAnonymous){

                        }else{
                            executed = false;
                        }
                    }else{
                        executed = false;
                    }
                }else{
                    executed = false;
                }
            }
            for (var c_id in m_callpy.client_data.site_info.auto[siteCondId]['conditions']){
                /*
                WHY: ?
                if (data && data["form_id"] && data["button_id"] && m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].type != "BUTTON_PRESSED") {
                    executed = false;
                    continue;
                }
                */
                //console.log("Проверка условия: ", m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id]);
                switch (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].type){
                    case 'SITE_TIME':
                        if (new Date().getTime() - m_callpy.m_user.last_visit_time < m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data * 1000) executed = false;
                        else executed_partially = true;
                        break;
                    case 'PAGE_TIME':
                        if (new Date().getTime() - m_callpy.m_user.last_page_time < m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data * 1000) executed = false;
                        else executed_partially = true;
                        break;
                    case 'PAGE_VIEWED':
                        if (m_callpy.m_storage.pageViews < m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data ) executed = false;
                        else executed_partially = true;
                        break;
                    case 'PAGE_URL':
                        switch (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].compare_type){
                            case 'INCLUDES':
                                if (decodeURI(window.location.href).indexOf(m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data) == -1) executed = false;
                                else executed_partially = true;
                                break;
                            case 'NOT_INCLUDES':
                                if (decodeURI(window.location.href).indexOf(m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data) != -1) executed = false;
                                else executed_partially = true;
                                break;
                            case 'EQUALS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data != decodeURI(window.location.href)) executed = false;
                                else executed_partially = true;
                                break;
                            case 'NOT_EQUALS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data == decodeURI(window.location.href)) executed = false;
                                else executed_partially = true;
                                break;
                            case 'MORE':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data <= decodeURI(window.location.href)) executed = false;
                                else executed_partially = true;
                                break;
                            case 'LESS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data >= decodeURI(window.location.href)) executed = false;
                                else executed_partially = true;
                                break;
                        }
                        break;
                    case 'GOAL_REACHED':
                        if (m_callpy.client_data.site_info.goals && m_callpy.client_data.site_info.goals[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data] && m_callpy.client_data.site_info.goals[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data].goals){
                            if (!m_callpy.client_data.clientInfo.goalsData || !m_callpy.client_data.clientInfo.goalsData[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data] || m_callpy.client_data.site_info.goals[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data].goals.length > m_callpy.client_data.clientInfo.goalsData[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data].length) executed = false;
                            else executed_partially = true;
                        }else{
                            executed = false;
                        }
                        break;
                    case 'GOAL_NOT_REACHED':
                        if (m_callpy.client_data.site_info.goals && m_callpy.client_data.site_info.goals[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data] && m_callpy.client_data.site_info.goals[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data].goals){
                            if (!m_callpy.client_data.clientInfo.goalsData || !m_callpy.client_data.clientInfo.goalsData[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data] || m_callpy.client_data.site_info.goals[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data].goals.length > m_callpy.client_data.clientInfo.goalsData[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data].length) executed_partially = true;
                            else executed = false;
                        }else{
                            executed = true;
                        }
                        break;
                    case 'CHAT_MESSAGE':
                        //в качестве дополнительных данных передаётся сообщение чата. Условие может быть выполнено только в момент написания (непосредственного вызова проверки)
                        if (data && data["message"]){
                            //фильтр по словам, если задан
                            if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data){
                                var words = m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data.toLowerCase().split(','), exists = false;
                                for (var i=0; i<words.length; i++){
                                    if (data["message"].toLowerCase().indexOf(words[i].trim()) != -1) {
                                        exists = true;
                                        break;
                                    }
                                }
                                if (!exists) executed = false;
                                else executed_partially = true;
                            }
                        }else{
                            executed = false;
                        }
                        break;
                    case 'CHAT_MESSAGE_ABSENCE':
                        //в качестве дополнительных данных передаётся сообщение чата. Условие может быть выполнено только в момент написания (непосредственного вызова проверки)
                        if (data && data["message"]){
                            //фильтр по словам, если задан
                            if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data){
                                var words = m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data.toLowerCase().split(','), exists = false;
                                for (var i=0; i<words.length; i++){
                                    if (data["message"].toLowerCase().indexOf(words[i].trim()) != -1) {
                                        exists = true;
                                        break;
                                    }
                                }
                                if (exists) executed = false;
                                else executed_partially = true;
                            }
                        }else{
                            executed = false;
                        }
                        break;
                    case 'CHAT_MESSAGE_COUNT':
                        //фильтр по количеству сообщений в чат (считаем за последний диалог, т.е. разрыв не более 30 мин м/у сообщениями)
                        if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data){
                            var mCount = 0, curTime = new Date().getTime();
                            //console.log(m_callpy.m_chat.history);
                            for (var i = m_callpy.m_chat.history.length - 1; i>=0; i--){
                                //сообщение самого клиента
                                //console.log(m_callpy.m_chat.history[i]);
                                if (curTime - m_callpy.m_chat.history[i].timestamp * 1000 > 30*60*1000){
                                    //сообщение относится к другому диалогу
                                    break;
                                }
                                curTime = m_callpy.m_chat.history[i].timestamp * 1000;
                                if ((!m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].recieved == 0) || (m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].received == 0)){
                                    mCount++;
                                }
                            }
                            if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data > mCount) executed = false;
                            else executed_partially = true;
                        }
                        break;
                    case 'IN_DPRT':
                        if (m_callpy.client_data.department_id != m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data) executed = false;
                        else executed_partially = true;
                        break;
                    case 'ATTACHED_TO_CONS':
                        if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].compare_type != "NOT_INCLUDES" && m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].compare_type != "NOT_EQUAL"){
                            if (m_callpy.client_data.peer_key != m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data) executed = false;
                            else executed_partially = true;
                        }else{
                            if (m_callpy.client_data.peer_key == m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data) executed = false;
                            else executed_partially = true;
                        }
                        break;
                    case 'GEO':
                        var city = m_callpy.client_data.clientInfo.additionalData.city.toLowerCase(), country = m_callpy.client_data.clientInfo.additionalData.country.toLowerCase(),
                            geo = m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data.toLowerCase().split(','), exists = false;
                            for (var i=0; i<geo.length; i++){
                                if (city == geo[i] || country == geo[i]){
                                    exists = true;
                                    break;
                                }
                            }
                        if (!exists) executed = false;
                        else executed_partially = true;
                        break;
                    case 'NO_ANSWER':
                        var last_message_time = new Date().getTime(), curTime = new Date().getTime();
                        for (var i = m_callpy.m_chat.history.length - 1; i>=0; i--){
                            //сообщение самого клиента
                            if (last_message_time - m_callpy.m_chat.history[i].timestamp * 1000 > 30*60*1000 || (m_callpy.m_chat.history[i].type!=6 && ((!m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].recieved != 0) || (m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].received != 0)))){
                                //сообщение относится к другому диалогу, либо было чье-то сообщение
                                break;
                            }
                            //curTime = m_callpy.m_chat.history[i].timestamp * 1000;
                            if ((!m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].recieved == 0) || (m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].received == 0)) last_message_time = m_callpy.m_chat.history[i].timestamp * 1000;
                        }
                        if (curTime == last_message_time || (curTime - last_message_time < m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data * 1000)) executed = false;
                        else executed_partially = true;
                        break;
                    case 'IS_CONS_ATTACHED':
                        if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data != 0){
                            if (m_callpy.client_data.peer_key == 0) executed = false;
                            else executed_partially = true;
                        }else{
                            if (m_callpy.client_data.peer_key != 0) executed = false;
                            else executed_partially = true;
                        }
                        break;
                    case 'SITE_VISIT_NUM':
                        if (localStorage["callpy_vsts"] < m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data) executed = false;
                        else executed_partially = true;
                        break;
                    case 'PHONE_FILLED':
                        if (m_callpy.client_data.department_id != m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data != 0){
                            if (!m_callpy.client_data.clientInfo.formData || !m_callpy.client_data.clientInfo.formData.contactForm || !m_callpy.client_data.clientInfo.formData.contactForm.phone || m_callpy.client_data.clientInfo.formData.contactForm.phone.length == 0) executed = false;
                            else executed_partially = true;
                        }else{
                            if (m_callpy.client_data.clientInfo.formData && m_callpy.client_data.clientInfo.formData.contactForm && m_callpy.client_data.clientInfo.formData.contactForm.phone && m_callpy.client_data.clientInfo.formData.contactForm.phone.length != 0) executed = false;
                            else executed_partially = true;
                        }
                        break;
                    case 'NAME_FILLED':
                        if (m_callpy.client_data.department_id != m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data != 0){
                            if (!m_callpy.client_data.clientInfo.formData || !m_callpy.client_data.clientInfo.formData.contactForm || !m_callpy.client_data.clientInfo.formData.contactForm.name || m_callpy.client_data.clientInfo.formData.contactForm.name.length == 0) executed = false;
                            else executed_partially = true;
                        }else{
                            if (m_callpy.client_data.clientInfo.formData && m_callpy.client_data.clientInfo.formData.contactForm && m_callpy.client_data.clientInfo.formData.contactForm.name && m_callpy.client_data.clientInfo.formData.contactForm.name.length != 0) executed = false;
                            else executed_partially = true;
                        }
                        break;
                    case 'FORM_FILLED':
                        if ((!m_callpy.client_data.clientInfo.formData || !m_callpy.client_data.clientInfo.formData.departmentForm || !m_callpy.client_data.clientInfo.formData.departmentForm[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data])&&(!m_callpy.client_data.clientInfo.formData || !m_callpy.client_data.clientInfo.formData.siteForm || !m_callpy.client_data.clientInfo.formData.siteForm[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data])) executed = false;
                        else executed_partially = true;
                        break;
                    case 'FORM_NOT_FILLED':
                        if (!((!m_callpy.client_data.clientInfo.formData || !m_callpy.client_data.clientInfo.formData.departmentForm || !m_callpy.client_data.clientInfo.formData.departmentForm[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data])&&(!m_callpy.client_data.clientInfo.formData || !m_callpy.client_data.clientInfo.formData.siteForm || !m_callpy.client_data.clientInfo.formData.siteForm[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data]))) executed = false;
                        else executed_partially = true;
                        break;
                    case 'FORM_FILLING':
                        //в качестве дополнительных данных передается ID формы
                        //условие может быть выполнено только в момент заполнения
                        if (data && data["form_id"]){
                            //фильтр по словам, если задан
                            if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data){
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data != data["form_id"]) executed = false;
                                else executed_partially = true;
                            }else executed = false;
                        }else{
                            executed = false;
                        }
                        break;
                    case 'SOURCE':
                        //проверка и по источнику, и по utm (если доступны)
                        var exists = false, utms;
                        if (m_callpy.client_data.clientInfo.additionalData && m_callpy.client_data.clientInfo.additionalData.fromref && m_callpy.client_data.clientInfo.additionalData.fromref.toLowerCase().indexOf(m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data.toLowerCase())!= -1) exists = true;
                        if (m_callpy.client_data.clientInfo.additionalData && m_callpy.client_data.clientInfo.additionalData.utms){
                            for (var utm in m_callpy.client_data.clientInfo.additionalData.utms){
                                utms = m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data.toLowerCase().split("=");
                                if (utms.length == 2 && utm == utms[0] && m_callpy.client_data.clientInfo.additionalData.utms[utm].toLowerCase() == utms[1]) exists = true;
                            }
                        }
                        if (!exists) executed = false;
                        else executed_partially = true;
                        break;
                    case 'PLATFORM':
                        if (m_callpy.client_data.clientInfo.additionalData.browser.toLowerCase().indexOf(m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data.toLowerCase()) == -1) executed = false;
                        else executed_partially = true;
                        break;
                    case 'CHAT_STATUS':
                        if ($jcallpy.callpy_status('api').visible && m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data == 0) executed = false;
                        else executed_partially = true;
                        if (!$jcallpy.callpy_status('api').visible && m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data == 1) executed = false;
                        else executed_partially = true;
                        break;
                    case 'CONS_ONLINE_EXIST':
                        var exists = false;
                        for (var mid in m_callpy.managers_list){
                            if (mid == 1) continue; //бота не считаем
                            if (m_callpy.managers_list[mid]){
                                exists = true;
                                break;
                            }
                        }
                        if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data == 1){
                            //условие, если есть консультанты онлайн
                            if (!exists) executed = false;
                            else executed_partially = true;
                        }else{
                            //если нет консультантов онлайн
                            if (exists) executed = false;
                            else executed_partially = true;
                        }

                        break;
                    case 'SPEC_CONS_IS_ONLINE':
                        if (!m_callpy.managers_list[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data] || !m_callpy.managers_list[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data].status || m_callpy.managers_list[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data].status != 1) executed = false;
                        else executed_partially = true;
                        break;
                    case 'BUTTON_PRESSED':
                        //в качестве дополнительных данных передаётся сообщение чата. Условие может быть выполнено только в момент написания (непосредственного вызова проверки)
                        if (data && data["form_id"] && data["button_id"]){
                            if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data != data["form_id"] || m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data != data["button_id"]) executed = false;
                            else executed_partially = true;
                        }else{
                            executed = false;
                        }
                        break;
                    case 'ACTIVE_DIALOG':
                        var last_message_time = new Date().getTime(), curTime = new Date().getTime(), consMessage = false, clientMessage = false;
                        for (var i = m_callpy.m_chat.history.length - 1; i>=0; i--){
                            //сообщение самого клиента
                            if (curTime - m_callpy.m_chat.history[i].timestamp * 1000 > 30*60*1000){
                                //сообщение относится к другому диалогу, либо было чье-то сообщение
                                break;
                            }
                            if (m_callpy.m_chat.history[i].type != 6){
                                if ((!m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].recieved == 0) || (m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].received == 0)) clientMessage = true;
                                else consMessage = true;
                            }
                            curTime = m_callpy.m_chat.history[i].timestamp * 1000;
                            last_message_time = m_callpy.m_chat.history[i].timestamp * 1000;
                        }
                        if ((consMessage && clientMessage) && m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data == 0) executed = false;
                        else executed_partially = true;
                        if ((!consMessage || !clientMessage) && m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data == 1) executed = false;
                        else executed_partially = true;
                        break;
                    case 'DIALOG_EXISTS':
                        //наличие диалога (считаем наличие сообщений с двух сторон), считаем в рамках только одного диалога
                        var last_message_time = null, curTime = new Date().getTime(), consMessage = false, clientMessage = false;
                        for (var i = m_callpy.m_chat.history.length - 1; i>=0; i--){
                            //сообщение самого клиента
                            if (last_message_time && curTime - m_callpy.m_chat.history[i].timestamp * 1000 > 30*60*1000){
                                //сообщение относится к другому диалогу, сброс
                                consMessage = false;
                                clientMessage = false;
                                curTime = m_callpy.m_chat.history[i].timestamp * 1000;
                                last_message_time = null;
                                continue;
                                //break;
                            }
                            if (m_callpy.m_chat.history[i].type != 6){
                                if ((!m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].recieved == 0) || (m_callpy.m_chat.history[i].received && m_callpy.m_chat.history[i].received == 0)) clientMessage = true;
                                else consMessage = true;
                            }
                            curTime = m_callpy.m_chat.history[i].timestamp * 1000;
                            last_message_time = m_callpy.m_chat.history[i].timestamp * 1000;
                            if (consMessage && clientMessage) break;
                        }
                        if ((consMessage && clientMessage) && m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data == 0) executed = false;
                        else executed_partially = true;
                        if ((!consMessage || !clientMessage) && m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data == 1) executed = false;
                        else executed_partially = true;
                        break;
                    case 'DAYTIME':
                        var hour = new Date().getHours();
                        switch (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].compare_type){
                            case 'EQUALS':
                            case 'INCLUDES':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data != hour) executed = false;
                                else executed_partially = true;
                                break;
                            case 'NOT_EQUALS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data == hour) executed = false;
                                else executed_partially = true;
                                break;
                            case 'MORE':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data > hour) executed = false;
                                else executed_partially = true;
                                break;
                            case 'LESS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data < hour) executed = false;
                                else executed_partially = true;
                                break;
                            default:
                                executed = false;
                                break;
                        }
                        break;
                    case 'DAYTIMEZONE':
                        var hour = this.getHoursZone(m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data != '' ? m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data : "+3");
                        switch (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].compare_type){
                            case 'EQUALS':
                            case 'INCLUDES':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data != hour) executed = false;
                                else executed_partially = true;
                                break;
                            case 'NOT_EQUALS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data == hour) executed = false;
                                else executed_partially = true;
                                break;
                            case 'MORE':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data > hour) executed = false;
                                else executed_partially = true;
                                break;
                            case 'LESS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data < hour) executed = false;
                                else executed_partially = true;
                                break;
                            default:
                                executed = false;
                                break;
                        }
                        break;
                    case 'DAYOFWEEK':
                        var dayofweek = new Date().getDay();
                        if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data != dayofweek) executed = false;
                        else executed_partially = true;
                        break;
                    case 'DATE':
                        var curr_date = new Date(), year, month, day, cdate;
                        year = curr_date.getFullYear();
                        month = curr_date.getMonth() + 1;
                        if (month < 10) month = "0" + month;
                        day = curr_date.getDate();
                        if (day < 10) day = "0" + day;
                        cdate = year + "-" + month + "-" + day;
                        switch (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].compare_type){
                            case 'EQUALS':
                            case 'INCLUDES':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data != cdate) executed = false;
                                else executed_partially = true;
                                break;
                            case 'NOT_EQUALS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data == cdate) executed = false;
                                else executed_partially = true;
                                break;
                            case 'MORE':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data > cdate) executed = false;
                                else executed_partially = true;
                                break;
                            case 'LESS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data < cdate) executed = false;
                                else executed_partially = true;
                                break;
                            default:
                                executed = false;
                                break;
                        }
                        break;
                    case 'CONDITION_REACHED':
                        //проверяем то, что определенные условия достигались клиентом
                        //достижение условий клиентом записывается в LS, вместе с временем достижения и кол-вом раз
                        //время, не более которого должно пройти со времени достижерния, указывается в данных
                        var string_data = m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data.split('|');
                        if (string_data.length < 2) string_data = [0,0];
                        if (_this.savedCondData[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data] &&
                            _this.savedCondData[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data]['num'] &&
                            _this.savedCondData[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data]['num'] >= parseInt(string_data[0]) &&
                            _this.savedCondData[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data]['last_time'] &&
                            (new Date.getTime() / 1000 - _this.savedCondData[m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data]['last_time']) <= parseInt(string_data[1])
                        ){
                            executed_partially = true;
                        }else{
                            executed = false;
                        }
                        break;
                    case 'TAB_IS_ACTIVE':
                        if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data != 0){
                            if (!m_callpy.m_storage.activeTab) executed = false;
                            else executed_partially = true;
                        }else{
                            if (m_callpy.m_storage.activeTab) executed = false;
                            else executed_partially = true;
                        }
                        break;
                    case 'OPENING_CHAT':
                        if (!data || !data["chat_open"]) executed = false;
                        else executed_partially = true;
                        break;
                    case 'PRINTING_CHAT':
                        if (!data || !data["chat_printing"]) executed = false;
                        else executed_partially = true;
                        break;
                    case 'ENTERING_DPRT':
                        if (!data || !data["entering_dprt"] || data["entering_dprt"] != m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].int_data) executed = false;
                        else executed_partially = true;
                        break;
                    case 'CLOSING_DIALOG':
                        if (!data || !data["closing_dialog"]) executed = false;
                        else executed_partially = true;
                        break;
                    case 'DIALUP_END':
                        if (!data || !data["dialup_end"]) executed = false;
                        else executed_partially = true;
                        break;
                    default:
                        break;
                }
            }
            //console.log("executed:", executed);
            if (executed || (m_callpy.client_data.site_info.auto[siteCondId]['logic_type'] == 'OR' && executed_partially)){
                //UPDATED: записываем в LS время последнего достижения условия
                if (!_this.savedCondData[siteCondId]){
                    _this.savedCondData[siteCondId] = {
                        id: siteCondId,
                        num: 1,
                        last_time: new Date().getTime()
                    };
                }else{
                    if (!_this.savedCondData[siteCondId]["num"]) _this.savedCondData[siteCondId]["num"] = 1;
                    else _this.savedCondData[siteCondId]["num"]++;
                    _this.savedCondData[siteCondId]["last_time"] = new Date().getTime();
                }
                localStorage["callpy_site_conditions"] = JSON.stringify(_this.savedCondData);
                //UPDATED: отдельно отправляем запрос о том, что сценарий был выполнен
                /*
                if (m_callpy.client_data.saveSysMes){
                    //только если стоит флаг о записи системных сообщений, чтобы не грузить БД
                    //для установки флага требуется какое-либо взаимодействие с консультантом - чат, звонок
                    m_callpy.m_bridge.to_fms({
                        action: "save_sys_log",
                        peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0),
                        site: m_callpy.client_data.site,
                        domain: m_callpy.client_data.site,
                        messages: JSON.stringify([{type: "siteCondition", message: siteCondId, timestamp: 1}])
                    },function(data){

                    });

                }
                */

                //набор условий полностью выполнен, отправка данных на сервер (либо задержка и отправка)
                if (m_callpy.client_data.site_info.auto[siteCondId]['actions']){
                    if (siteCondId == 2051){
                        $jcallpy.callpy_message('_addSys', {type: 'change_manager', text: "Диалог завершён!"});
                        return;
                    }
                    for (var a_id in m_callpy.client_data.site_info.auto[siteCondId]['actions']){
                        var curTime = new Date().getTime();
                        if (m_callpy.client_data.site_info.auto[siteCondId]['actions'][a_id].timeout || curTime - m_callpy.m_user.last_visit_time < 4000){
                            var timeout = Math.max(m_callpy.client_data.site_info.auto[siteCondId]['actions'][a_id].timeout * 1000, 4000 - (curTime - m_callpy.m_user.last_visit_time));
                            (function(siteCondId, a_id) {
                                setTimeout(function(){
                                    _this.sendAction(siteCondId, m_callpy.client_data.site_info.auto[siteCondId]['actions'][a_id])
                                }, timeout + (Math.random())*1000);
                            })(siteCondId, a_id);

                        }else{
                            _this.sendAction(siteCondId, m_callpy.client_data.site_info.auto[siteCondId]['actions'][a_id]);
                        }
                    }
                }
            }
        }
    };

    this.sendAction = function(siteCondId, action)
    {
        //console.log("Send Action", action);
        //проверка, сколько раз это действие исполнялось и необходимо ли сбросить
        //FIXED: берём напрямую из LS, уже могло измениться
        if (localStorage["callpy_conditions"]){
            try{
                _this.savedData = JSON.parse(localStorage["callpy_conditions"]);
            }catch (e) {
                _this.savedData = {};
            }

        }
        if (_this.savedData[action['id']]){
            if (_this.savedData[action['id']]['first_time_act']){
                //проверка, возможно, необходимо уже сбросить выполненность действия по таймеру
                if (new Date().getTime() - _this.savedData[action['id']]['first_time_act'] > action["reset_hours"] * 60 * 60 * 1000){
                    //сбрасываем количество выполнений и счётчик сброса
                    _this.savedData[action['id']]['executes_num'] = 0;
                    _this.savedData[action['id']]['first_time_act'] = 0;
                    localStorage["callpy_conditions"] = JSON.stringify(_this.savedData);
                }
            }
            if (_this.savedData[action['id']]['executes_num'] >= action["executes_num"] && action["executes_num"] != 0){
                //действие уже выполнялось заданное число раз
                //UPDATED: если указан 0 - кол-во выполнения не ограничено
                return;
            }
        }else{
            _this.savedData[action['id']] = {
                'executes_num': 0,
                'first_time_act': 0
            };
        }
        //выполняем действие
        _this.savedData[action['id']]['executes_num'] += 1;
        _this.savedData[action['id']]['first_time_act'] = new Date().getTime();
        localStorage["callpy_conditions"] = JSON.stringify(_this.savedData);

        //отсылка команды серверу. Для некоторых действий необходим callback сервера; большинство выполнит сам сервер
        //клиенту известен только id действия, его назначение - нет
        //TODO: необходимо реализовать проверку (хотя бы некоторых) условий на стороне сервера; команда на выполнение действий может быть инициирована клиентом вручную
        m_callpy.m_bridge.to_fms({
            action: "do_action",
            site_cond_id: siteCondId,
            action_id: action['id'],
            peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0),
            site: m_callpy.client_data.site,
            domain: m_callpy.client_data.site
        },function(data){
            if (data == "" || !data) return;
            data = JSON.parse(data);
            if (data["result"] && data["action"]){
                switch (data["action"]){
                    case 'auto_message':
                        //TODO: REFACTOR: дублирование кода
                        var messageData = {
                            "department_id": m_callpy.client_data.department_id,
                            "extData": [],
                            "managerId": data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                            "managerName": data["manager_name"] != '' ? data["manager_name"] : m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                            "message" : m_callpy.m_user.replacePatterns(data["message"]),
                            "receiver" : m_callpy.client_data.key,
                            "sender" : data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                            "status_read": 0,
                            "status_received": 0,
                            "status_sent": new Date().getTime() / 1000,
                            "time": new Date().getTime() / 1000,
                            "timestamp": new Date().getTime() / 1000,
                            "type": 6,
                            "received": 1,
                            read: 1
                        };
                        if (!messageData["managerId"]) {
                            //нет назначенного консультанта
                            return;
                        }

                        $jcallpy.callpy_message('add', {
                            text: m_callpy.m_user.replacePatterns(data["message"]),
                            from: 1,
                            auto: true,
                            time: new Date().getTime(),
                            read: 0,
                            messageType: 6,
                            name: messageData["managerName"]
                            //messageType: 6
                        });

                        //UPDATED: для GA
                        if (window.gtag){
                            window.gtag('event', 'auto_message', {
                                'event_category': 'callpy',
                                'event_label': 'a_id'+(action["id"]?action["id"]:'_rand')
                            });
                        } else if (window.ga){
                            window.ga('send', 'event', 'callpy', 'autogreeting', 'a_id'+(action["id"]?action["id"]:'_rand'));
                        }

                        m_callpy.m_chat.history.push(messageData);

                        //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                        m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                            "message": data["message"],
                            "messageData": JSON.stringify(messageData),
                            "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                            "updateAutoCounter": 0,
                            "time": new Date().getTime()
                        }));
                        break;
                    case 'SHOW_CHAT':
                        //TODO GUI: показать чат
                        callpy_api.chat('show');
                        break;
                    case 'HIDE_CHAT':
                        //TODO GUI: свернуть чат
                        callpy_api.chat('hide');
                        break;
                    case 'SOUND':
                        //TODO GUI: проиграть звук сообщения
                        break;
                    case 'TARGET_BLANK':
                        window.open(data["url"], "_blank");
                        break;
                    case 'SAVE_CUSTOM_FORM':
                    case 'SAVE_NAME':
                    case 'SAVE_PHONE':
                    case 'SAVE_EMAIL':
                        m_callpy.m_user.formData({
                            formType: "customForm",
                            data: data["data"]
                        });
                        break;
                    case 'REACH_GOAL':
                        //достигаем цели
                        if (data["id"]){
                            if (m_callpy.client_data.clientInfo.goalsData && m_callpy.client_data.clientInfo.goalsData[data["id"]] && m_callpy.client_data.clientInfo.goalsData[data["id"]].length){
                                //цель уже достигалась
                            }else{
                                if (m_callpy.client_data.site_info.goals && m_callpy.client_data.site_info.goals[data["id"]] && m_callpy.client_data.site_info.goals[data["id"]]["goals"] && m_callpy.client_data.site_info.goals[data["id"]]["goals"].length){

                                    if (!m_callpy.client_data.clientInfo.goalsData) m_callpy.client_data.clientInfo.goalsData = {};
                                    if (!m_callpy.client_data.clientInfo.goalsData[data["id"]]) m_callpy.client_data.clientInfo.goalsData[data["id"]] = [];

                                    for (var i=0; i<m_callpy.client_data.site_info.goals[data["id"]]["goals"].length; i++){
                                        if (m_callpy.client_data.site_info.goals[data["id"]]["goals"][i]["id"]){
                                            m_callpy.client_data.clientInfo.goalsData[data["id"]].push(m_callpy.client_data.site_info.goals[data["id"]]["goals"][i]["id"]);
                                        }
                                    }

                                    //UPDATED: проверка всех условий
                                    m_callpy.m_autos.checkAllConditions({goal_id: data["id"]});

                                }

                            }
                        }
                        break;
                    case 'S_TRAIDIN':
                        //TODO: хардкод, перенести на сценарии
                        if (data['city'] == 1){
                            var messageData = {
                                "department_id": m_callpy.client_data.department_id,
                                "extData": [],
                                "managerId": data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "managerName": (data["manager_name"] && data["manager_name"] != '') ? data["manager_name"] : m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                                "message" : "Поздравляем! В вашем городе действует программа Trade-in. Программа действует при покупке через официальный интернет-магазин. Вам предоставляется возможность получить дополнительнкю скидку на приобретаемое устройство из категории Сматрфоны, Планшеты и Смарт часы. Если коротко рассказать о наших правилах, то всё просто: устройство должно быть русифицированным, должно иметь сертификацию, а также должны отсутствовать видимые повреждения (сколы, трещины, вмятины). Небольшие царапины допускаются.\n" +
                                    "\n" +
                                    "У нас на сайте есть чек-лист, по которому курьер оценивает ваше устройство, прежде чем принять его в трейд ин. Пожалуйста, обратите внимание, что бывшее в употреблении устройство в случае возврата или обмена товара возврату не подлежит, при этом возврату подлежат денежные средства, фактически полученные в оплату товара.\n" +
                                    "\n" +
                                    "Если всё понятно, давайте рассчитаем стоимость скидки с учётом Trade-in?",
                                "receiver" : m_callpy.client_data.key,
                                "sender" : data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "status_read": 0,
                                "status_received": 0,
                                "status_sent": new Date().getTime() / 1000,
                                "time": new Date().getTime() / 1000,
                                "timestamp": new Date().getTime() / 1000,
                                "type": 6,
                                "received": 1,
                                read: 1
                            };
                            if (!messageData["managerId"]) {
                                //нет назначенного консультанта
                                return;
                            }

                            $jcallpy.callpy_message('add', {
                                text: m_callpy.m_user.replacePatterns(messageData["message"]),
                                from: 1,
                                auto: true,
                                time: new Date().getTime(),
                                read: 0,
                                messageType: 6
                                //messageType: 6
                            });

                            m_callpy.m_chat.history.push(messageData);

                            //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                                "message": messageData["message"],
                                "messageData": JSON.stringify(messageData),
                                "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                                "updateAutoCounter": 0,
                                "time": new Date().getTime()
                            }));

                            //form_id - 13585
                            m_callpy.m_user.fillForm({form_id: 13585});
                        }else{
                            var messageData = {
                                "department_id": m_callpy.client_data.department_id,
                                "extData": [],
                                "managerId": data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "managerName": (data["manager_name"] && data["manager_name"] != '') ? data["manager_name"] : m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                                "message" : "К сожалению, в вашем городе пока нет Trade-in :( но мы постоянно работаем на увеличением списка городов. Посмотрите пожалуйста ближайшие города, где доступен данный сервис:\n1. "+data["cities"][0]+"\n2. "+data["cities"][1]+"\n3. "+data["cities"][2],
                                "receiver" : m_callpy.client_data.key,
                                "sender" : data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "status_read": 0,
                                "status_received": 0,
                                "status_sent": new Date().getTime() / 1000,
                                "time": new Date().getTime() / 1000,
                                "timestamp": new Date().getTime() / 1000,
                                "type": 6,
                                "received": 1,
                                read: 1
                            };
                            if (!messageData["managerId"]) {
                                //нет назначенного консультанта
                                return;
                            }

                            $jcallpy.callpy_message('add', {
                                text: m_callpy.m_user.replacePatterns(messageData["message"]),
                                from: 1,
                                auto: true,
                                time: new Date().getTime(),
                                read: 0,
                                messageType: 6
                                //messageType: 6
                            });

                            m_callpy.m_chat.history.push(messageData);

                            //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                                "message": messageData["message"],
                                "messageData": JSON.stringify(messageData),
                                "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                                "updateAutoCounter": 0,
                                "time": new Date().getTime()
                            }));
                            //form_id - 13587
                            m_callpy.m_user.fillForm({form_id: 13587});
                        }
                        break;
                    case 'S_DELIVERY':
                        if (data['city'] == 1){
                            var messageData = {
                                "department_id": m_callpy.client_data.department_id,
                                "extData": [],
                                "managerId": data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "managerName": (data["manager_name"] && data["manager_name"] != '') ? data["manager_name"] : m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                                "message" : "Поздравляем! в вашем городе есть курьерская доставка, и она совершенно бесплатна! Доставка осуществляется 7 (семь) дней в неделю.\n" +
                                    "\n" +
                                    "При совершении Заказа до 14:00 часов по Московскому времени, срок доставки Товара начинает исчисляться с дня, в который подтвержден Заказ.\n" +
                                    "\n" +
                                    "При совершении Заказа после 14:00 часов по Московскому времени, срок доставки Товара начинает исчисляться с дня, следующего за днем подтверждения Заказа.\n" +
                                    "\n" +
                                    "Если вам необходимо изменить дату и время доставки, пожалуйста, позвоните в Колл-центр 8-800-555-55-66 или напишите нам в чат, выбрав опцию Заказ - Внести изменения в заказ.\n" +
                                    "\n" +
                                    "После оформления заказа с вами свяжутся операторы Колл-центра и согласуют удобный для вас интервал доставки.\n" +
                                    "\n" +
                                    "Если у вас остались ещё какие-то вопросы, наши консультанты сейчас вам помогут! Сроки доставки мелкогабаритного товара "+data["DeliveryShort"]+", крупногабаритного товара "+data["DeliveryLong"],
                                "receiver" : m_callpy.client_data.key,
                                "sender" : data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "status_read": 0,
                                "status_received": 0,
                                "status_sent": new Date().getTime() / 1000,
                                "time": new Date().getTime() / 1000,
                                "timestamp": new Date().getTime() / 1000,
                                "type": 6,
                                "received": 1,
                                read: 1
                            };
                            if (!messageData["managerId"]) {
                                //нет назначенного консультанта
                                return;
                            }

                            $jcallpy.callpy_message('add', {
                                text: m_callpy.m_user.replacePatterns(messageData["message"]),
                                from: 1,
                                auto: true,
                                time: new Date().getTime(),
                                read: 0,
                                messageType: 6
                                //messageType: 6
                            });

                            m_callpy.m_chat.history.push(messageData);

                            //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                                "message": messageData["message"],
                                "messageData": JSON.stringify(messageData),
                                "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                                "updateAutoCounter": 0,
                                "time": new Date().getTime()
                            }));

                            //form_id - 13599
                            m_callpy.m_user.fillForm({form_id: 13599});
                        }else{
                            var messageData = {
                                "department_id": m_callpy.client_data.department_id,
                                "extData": [],
                                "managerId": data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "managerName": (data["manager_name"] && data["manager_name"] != '') ? data["manager_name"] : m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                                "message" : "Нам очень жаль, но пока в вашем городе нет опции бесплатной курьерской доставки. Но мы непрерывно работаем над увеличением списка городов!",
                                "receiver" : m_callpy.client_data.key,
                                "sender" : data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "status_read": 0,
                                "status_received": 0,
                                "status_sent": new Date().getTime() / 1000,
                                "time": new Date().getTime() / 1000,
                                "timestamp": new Date().getTime() / 1000,
                                "type": 6,
                                "received": 1,
                                read: 1
                            };
                            if (!messageData["managerId"]) {
                                //нет назначенного консультанта
                                return;
                            }

                            $jcallpy.callpy_message('add', {
                                text: m_callpy.m_user.replacePatterns(messageData["message"]),
                                from: 1,
                                auto: true,
                                time: new Date().getTime(),
                                read: 0,
                                messageType: 6
                                //messageType: 6
                            });

                            m_callpy.m_chat.history.push(messageData);

                            //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                                "message": messageData["message"],
                                "messageData": JSON.stringify(messageData),
                                "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                                "updateAutoCounter": 0,
                                "time": new Date().getTime()
                            }));
                            //form_id - 13599
                            m_callpy.m_user.fillForm({form_id: 13599});
                        }
                        break;
                    case 'S_PICKUP':
                        if (data['city'] == 1){
                            var msg = "Доступные пункты самовывоза в вашем городе:";
                            for (var i in data["endpoints"]){
                                if (data["endpoints"][i]["Address"] && data["endpoints"][i]["WorkingTime"]){
                                    msg += "\n" + data["endpoints"][i]["Address"]+" ("+data["endpoints"][i]["WorkingTime"]+")";
                                }
                            }
                            var messageData = {
                                "department_id": m_callpy.client_data.department_id,
                                "extData": [],
                                "managerId": data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "managerName": (data["manager_name"] && data["manager_name"] != '') ? data["manager_name"] : m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                                "message" : msg,
                                "receiver" : m_callpy.client_data.key,
                                "sender" : data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "status_read": 0,
                                "status_received": 0,
                                "status_sent": new Date().getTime() / 1000,
                                "time": new Date().getTime() / 1000,
                                "timestamp": new Date().getTime() / 1000,
                                "type": 6,
                                "received": 1,
                                read: 1
                            };
                            if (!messageData["managerId"]) {
                                //нет назначенного консультанта
                                return;
                            }

                            $jcallpy.callpy_message('add', {
                                text: m_callpy.m_user.replacePatterns(messageData["message"]),
                                from: 1,
                                auto: true,
                                time: new Date().getTime(),
                                read: 0,
                                messageType: 6
                                //messageType: 6
                            });

                            m_callpy.m_chat.history.push(messageData);

                            //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                                "message": messageData["message"],
                                "messageData": JSON.stringify(messageData),
                                "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                                "updateAutoCounter": 0,
                                "time": new Date().getTime()
                            }));

                            //form_id - 13599
                            m_callpy.m_user.fillForm({form_id: 13599});
                        }else{
                            var messageData = {
                                "department_id": m_callpy.client_data.department_id,
                                "extData": [],
                                "managerId": data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "managerName": (data["manager_name"] && data["manager_name"] != '') ? data["manager_name"] : m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                                "message" : "Сожалеем, но в вашем городе пока нет пунктов самовывоза.",
                                "receiver" : m_callpy.client_data.key,
                                "sender" : data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "status_read": 0,
                                "status_received": 0,
                                "status_sent": new Date().getTime() / 1000,
                                "time": new Date().getTime() / 1000,
                                "timestamp": new Date().getTime() / 1000,
                                "type": 6,
                                "received": 1,
                                read: 1
                            };
                            if (!messageData["managerId"]) {
                                //нет назначенного консультанта
                                return;
                            }

                            $jcallpy.callpy_message('add', {
                                text: m_callpy.m_user.replacePatterns(messageData["message"]),
                                from: 1,
                                auto: true,
                                time: new Date().getTime(),
                                read: 0,
                                messageType: 6
                                //messageType: 6
                            });

                            m_callpy.m_chat.history.push(messageData);

                            //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                                "message": messageData["message"],
                                "messageData": JSON.stringify(messageData),
                                "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                                "updateAutoCounter": 0,
                                "time": new Date().getTime()
                            }));
                            //form_id - 13599
                            m_callpy.m_user.fillForm({form_id: 13599});
                        }
                        break;
                    case 'S_OLDTECH':
                        if (data['art'] == 1){
                            var messageData = {
                                "department_id": m_callpy.client_data.department_id,
                                "extData": [],
                                "managerId": data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "managerName": (data["manager_name"] && data["manager_name"] != '') ? data["manager_name"] : m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                                "message" : "Здорово, на вашу модель распространяются условии акции бесплатной установки. Но пожалуйста учтите, что бесплатная установка и вывоз старой техники действует только при оформлении заказов через официальный интернет-магазин Samsung.\n" +
                                    "\n" +
                                    "Для того, чтобы воспользоваться услугой, позвоните по номеру телефона: +7 (495) 989-43-04 Москва, МО +7 (812) 643-33-05 СПб, ЛО после подтверждения заказа, далее сообщите номер заказа и необходимые данные в момент оформления услуги бесплатной установки и договоритесь о дате и времени для установки.\n" +
                                    "\n" +
                                    "\n" +
                                    "\n" +
                                    "*Обратите внимание, что доставка и установка не осуществляются одновременно",
                                "receiver" : m_callpy.client_data.key,
                                "sender" : data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "status_read": 0,
                                "status_received": 0,
                                "status_sent": new Date().getTime() / 1000,
                                "time": new Date().getTime() / 1000,
                                "timestamp": new Date().getTime() / 1000,
                                "type": 6,
                                "received": 1,
                                read: 1
                            };
                            if (!messageData["managerId"]) {
                                //нет назначенного консультанта
                                return;
                            }

                            $jcallpy.callpy_message('add', {
                                text: m_callpy.m_user.replacePatterns(messageData["message"]),
                                from: 1,
                                auto: true,
                                time: new Date().getTime(),
                                read: 0,
                                messageType: 6
                                //messageType: 6
                            });

                            m_callpy.m_chat.history.push(messageData);

                            //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                                "message": messageData["message"],
                                "messageData": JSON.stringify(messageData),
                                "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                                "updateAutoCounter": 0,
                                "time": new Date().getTime()
                            }));

                            //form_id - 13599
                            m_callpy.m_user.fillForm({form_id: 13605});
                        }else{
                            var messageData = {
                                "department_id": m_callpy.client_data.department_id,
                                "extData": [],
                                "managerId": data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "managerName": (data["manager_name"] && data["manager_name"] != '') ? data["manager_name"] : m_callpy.managers_list[m_callpy.client_data.peer_key].name,
                                "message" : "Сожалеем, но на вашу модель не распространяются условия акции :( Если вы не уверены в корректности введенного артикула, вы можете посмотреть информацию тут https://www.samsung.com/ru/shop/installation/ или пригласить консультанта",
                                "receiver" : m_callpy.client_data.key,
                                "sender" : data["manager_id"]?data["manager_id"] : m_callpy.client_data.peer_key,
                                "status_read": 0,
                                "status_received": 0,
                                "status_sent": new Date().getTime() / 1000,
                                "time": new Date().getTime() / 1000,
                                "timestamp": new Date().getTime() / 1000,
                                "type": 6,
                                "received": 1,
                                read: 1
                            };
                            if (!messageData["managerId"]) {
                                //нет назначенного консультанта
                                return;
                            }

                            $jcallpy.callpy_message('add', {
                                text: m_callpy.m_user.replacePatterns(messageData["message"]),
                                from: 1,
                                auto: true,
                                time: new Date().getTime(),
                                read: 0,
                                messageType: 6
                                //messageType: 6
                            });

                            m_callpy.m_chat.history.push(messageData);

                            //менеджера необходимо уведомить, что у этого клиента сработало автоприветствие, чтобы он видел его в истории сообщений
                            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("automessage", {
                                "message": messageData["message"],
                                "messageData": JSON.stringify(messageData),
                                "save": (m_callpy.client_data.saveSysMes ? 1 : 0),
                                "updateAutoCounter": 0,
                                "time": new Date().getTime()
                            }));
                            //form_id - 13599
                            m_callpy.m_user.fillForm({form_id: 13605});
                        }
                        break;
                    case 'HIDE_BUTTONS':
                        $jcallpy.callpy_status('set', 'buttons_off', true);
                        break;
                }
            }
        });
    };

    //Проверка на условие блокировки выполнения - отдельно
    this.checkBlockConditions = function()
    {
        var executed = true, exists = false;
        if (!m_callpy.client_data.site_info.auto) return false;
        for (var siteCondId in m_callpy.client_data.site_info.auto) {
            if (!m_callpy.client_data.site_info.auto.hasOwnProperty(siteCondId)) continue;
            for (var c_id in m_callpy.client_data.site_info.auto[siteCondId]['conditions']) {
                switch (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].type) {
                    case 'PAGE_URL_BLOCK':
                        exists = true;
                        switch (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].compare_type){
                            case 'INCLUDES':
                                if (decodeURI(window.location.href).indexOf(m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data) == -1) executed = false;
                                break;
                            case 'NOT_INCLUDES':
                                if (decodeURI(window.location.href).indexOf(m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data) != -1) executed = false;
                                break;
                            case 'EQUALS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data != decodeURI(window.location.href)) executed = false;
                                break;
                            case 'NOT_EQUALS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data == decodeURI(window.location.href)) executed = false;
                                break;
                            case 'MORE':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data <= decodeURI(window.location.href)) executed = false;
                                break;
                            case 'LESS':
                                if (m_callpy.client_data.site_info.auto[siteCondId]['conditions'][c_id].string_data >= decodeURI(window.location.href)) executed = false;
                                break;
                        }
                        break;
                }
            }
        }
        if (window.location.href == "https://www.samsung.com/ru/smartphones/galaxy-s21-5g/buy/") executed = true;
        if (executed && exists){
            //к этому моменту изображение виджета может быть, необходимо его убрать
            //if (window.callpy_storage && window.callpy_storage.lastSave) {
                //для предотвращения загрузки из LS и восстановления некорректного html-состояния
                //время сбрасывать не надо, так как никакие скрипты не будут выполняться - записи в LS не будет происходить
                //window.callpy_storage.lastSave = parseInt(window.callpy_storage.lastSave) - 20000;
                if (document.getElementById("callpy")) document.getElementById("callpy").style.display = "none";
            //}
        }
        return executed && exists;
    };

};